import { Box } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useQueryCategories } from "../api/useQueryCategories";
import { useQueryGetSetting } from "../api/useQueryGetSetting";
import { ICategory } from "../interfaces/ICategory";
import { ISetting } from "../interfaces/ISetting";
import Footer from "./Footer";
import Header from "./Header";
import NavBar from "./NavBar";

const Page: FC<any> = ({ children }) => {
  const params = useParams();
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [setting, setSetting] = useState<ISetting>();
  const { data: catData, isLoading, isSuccess } = useQueryCategories();
  const scrollRef = useRef<any>();
  const {
    data: settingData,
    isLoading: isLoadingSetting,
    isSuccess: isSuccessSetting,
  } = useQueryGetSetting();

  useEffect(() => {
    if (catData && !isLoading && isSuccess) {
      setCategories(catData.categories);
    }
  }, [catData, isLoading, isSuccess]);

  useEffect(() => {
    if (settingData && !isLoadingSetting && isSuccessSetting) {
      setSetting(settingData?.setting);
    }
  }, [settingData, isLoadingSetting, isSuccessSetting]);

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div
      ref={scrollRef}
      className="h-screen w-screen overflow-hidden overflow-y-auto "
    >
      <Header
        isLoading={isLoading}
        slug={(params?.slug as string) ?? ""}
        categories={categories}
        setting={setting}
      />
      <NavBar
        isLoading={isLoading}
        slug={(params?.slug as string) ?? ""}
        categories={categories}
      />
      <Box
        className="p-0 "
        sx={{ minHeight: 350, backgroundColor: "#fbfbfb47" }}
      >
        {children}
      </Box>
      <Footer setting={setting} />
    </div>
  );
};

export default Page;
